import React from 'react'
import PropTypes from 'prop-types'

import { OTHER_FILTER, BRAND_PREFERENCE, DEMOGRAPHICS, MEDIA_PREFERENCE } from '../../../constants/commons';
import TopicHelpers from '../../../classes/TopicHelpers'
import TopicPlanFilterHelpers from '../../../classes/TopicPlanFilterHelpers'

class OtherFilterComponent extends React.Component {
  static propTypes = {
    filters: PropTypes.object.isRequired,
    setFilters: PropTypes.func.isRequired,
    otherFilters: PropTypes.array.isRequired,
    module: PropTypes.string.isRequired
  }

  render () {
    return (
      <ul className="checkList">
        <li><h4>Other Filters (AND)</h4></li>
        {(this.props.module === MEDIA_PREFERENCE) && this.li('ActiveContent', 'Active Content')}
        {(this.props.module !== BRAND_PREFERENCE && this.props.module !== DEMOGRAPHICS) && this.li('Anticipation', 'Anticipation')}
        {this.li('RemoveBottomQuintile', 'Remove Bottom Quintile')}
      </ul>
    )
  }

  li = (filter, text) => {
    let otherFilter = TopicPlanFilterHelpers.otherFilter(filter, this.props.module, this.props.filters)
    let currentValue = this.props.otherFilters && this.props.otherFilters.find(f => TopicHelpers.equals(f, otherFilter))
    const value = currentValue ? true : false
    return (
      <li>
        <input
          type="checkbox" id={`${text}`}
          checked={value}
          onChange={this.applyOtherFilter.bind(this, filter, text)} />
        <span></span>
        <label htmlFor={`${text}`}>{text}</label>
      </li>
    )
  }

  /** Apply one of the otherfilters and update the table filtering */
  applyOtherFilter = (filter, text) => {
    let filters = null
    if (filter !== 'None') {
      filters = TopicPlanFilterHelpers.otherFilter(filter, this.props.module, this.props.filters)
    }
    this.props.setFilters(filters, OTHER_FILTER, this.props.module, text)
  }
}

export default OtherFilterComponent